import { getApiUrl } from '../../../config/api';

const FEEDBACK_ACTOR_EMAIL_KEYS = [
  'admin_email',
  'employer_email',
  'recruiter_email',
  'company_email',
  'organizer_email',
];

export function getInterviewerFeedbackActorEmail() {
  if (typeof window === 'undefined') return '';
  for (const key of FEEDBACK_ACTOR_EMAIL_KEYS) {
    const value = window.sessionStorage.getItem(key) || window.localStorage.getItem(key) || '';
    if (value) return value.trim().toLowerCase();
  }
  return '';
}

async function readJson(response) {
  const text = await response.text();
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch {
    throw new Error(text || `Request failed (${response.status})`);
  }
}

async function requestJson(endpoint, options = {}) {
  const response = await fetch(getApiUrl(endpoint), {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });
  const data = await readJson(response);
  if (!response.ok) {
    throw new Error(data.error || data.message || `Request failed (${response.status})`);
  }
  return data;
}

export async function prepareInterviewerFeedback({
  bookingId,
  roomId,
  interviewerEmail,
  actorEmail,
}) {
  return requestJson('/api/meeting/interviewer-feedback/prepare', {
    method: 'POST',
    body: JSON.stringify({
      booking_id: bookingId,
      room_id: roomId,
      interviewer_email: interviewerEmail,
      actor_email: actorEmail,
    }),
  });
}

export async function deferInterviewerFeedback({
  bookingId,
  interviewerEmail,
  actorEmail,
}) {
  return requestJson('/api/meeting/interviewer-feedback/defer', {
    method: 'POST',
    body: JSON.stringify({
      booking_id: bookingId,
      interviewer_email: interviewerEmail,
      actor_email: actorEmail,
    }),
  });
}

export async function scheduleInterviewerFeedbackAutoEmail({
  bookingId,
  roomId,
  interviewerEmail,
  actorEmail,
}) {
  return requestJson('/api/meeting/interviewer-feedback/schedule-auto-email', {
    method: 'POST',
    body: JSON.stringify({
      booking_id: bookingId,
      room_id: roomId,
      interviewer_email: interviewerEmail,
      actor_email: actorEmail,
    }),
  });
}

export async function fetchInterviewerFeedbackSession(token) {
  const safe = encodeURIComponent(token || '');
  return requestJson(`/api/meeting/interviewer-feedback/session?token=${safe}`);
}

export async function saveInterviewerFeedbackSession(token, answers) {
  return requestJson('/api/meeting/interviewer-feedback/session', {
    method: 'PUT',
    body: JSON.stringify({ token, answers }),
  });
}

export async function submitInterviewerFeedback(token, answers, actorEmail) {
  return requestJson('/api/meeting/interviewer-feedback/submit', {
    method: 'POST',
    body: JSON.stringify({ token, answers, actor_email: actorEmail }),
  });
}

export async function fetchInterviewerFeedbackByBooking(bookingId, actorEmail) {
  const safe = encodeURIComponent(bookingId || '');
  const params = new URLSearchParams();
  if (actorEmail) {
    params.set('actor_email', actorEmail);
  }
  const query = params.toString();
  return requestJson(
    `/api/meeting/interviewer-feedback/booking/${safe}${query ? `?${query}` : ''}`
  );
}
